import { Component } from '@verndale/core';
import { rovingIndex } from '@verndale/roving-ux';
import { setParentBlockSize } from '../utils/dom';

class Accordion extends Component {
  setupDefaults() {
    const self = this;

    this.dom = {
      triggers: this.el.querySelectorAll('.accordion__item-trigger')
    };

    this.panels = [];
    this.dom.triggers.forEach((trigger) => {
      this.handleBlockSize(trigger);
    });

    rovingIndex({
      element: self.el,
      target: '.accordion__item-trigger'
    });
  }

  addListeners() {
    this.el.addEventListener('click', this.handleClick.bind(this));
  }

  handleBlockSize(el) {
    const panel = document.getElementById(el.getAttribute('aria-controls'));
    setParentBlockSize(panel.querySelector('.accordion__item-content'), panel);
  }

  handleClick(event) {
    const target = event.target;
    const panel = document.getElementById(target.getAttribute('aria-controls'));

    if (target.closest('.accordion__item-trigger')) {
      this.dom.triggers.forEach((trigger) => {
        if (trigger.getAttribute('aria-expanded') === 'true' && trigger.id !== target.closest('.accordion__item-trigger').id) {
          trigger.setAttribute('aria-expanded', false);
          this.triggerPanel = document.getElementById(trigger.getAttribute('aria-controls'));
          this.triggerPanel.classList.remove('accordion__item-panel--open');
        }
      });

      const isExpanded = target.getAttribute('aria-expanded') === 'true';

      if (!isExpanded) {
        target.setAttribute('aria-expanded', true);
        panel.classList.add('accordion__item-panel--open');
        this.handleBlockSize(target);
      } else {
        target.setAttribute('aria-expanded', false);
        panel.classList.remove('accordion__item-panel--open');
      }

      event.preventDefault();
    }
  }
}
export default Accordion;
